import { RemoteDeveloperCompany } from "../../../../data/usecases/developer-company/remote-developer-company";
import { DeveloperCompany } from "../../../../domain/models/developer-company.model";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteDeveloperCompanies = (): DeveloperCompany =>
  new RemoteDeveloperCompany(
    "/developer-companies",
    makeAxiosHttpClient(),
    settings.API_URL
  );
